import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var RectangleOutline = function RectangleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 20' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.227c0 1.497.777 2.273 2.274 2.273h7.452c1.497 0 2.274-.776 2.274-2.273V4.773c0-1.49-.777-2.273-2.274-2.273H6.274C4.777 2.5 4 3.283 4 4.773v10.454Zm1.371-.083V4.856c0-.645.336-.998 1.015-.998h7.221c.679 0 1.022.353 1.022.998v10.288c0 .645-.343.998-1.022.998H6.386c-.679 0-1.015-.353-1.015-.998Z"
  }));
};

RectangleOutline.displayName = 'RectangleOutline';
export default RectangleOutline;